import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { slug } from 'flarum/common/utils/string';
import ForumTrashPanel from './ForumTrashPanel';
export default class ForumsPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.items = [];
    this.byId = new Map();
    this.childrenMap = new Map();
    this.permissionItems = [];
    this.permissionById = new Map();
    this.permissionChildrenMap = new Map();
    this.filter = '';
    this.selectedId = null;
    this.moveParentId = '';
    this.moveLoading = false;
    this.createName = '';
    this.createSlug = '';
    this.createLoading = false;
    this.loading = false;
    this.error = '';
    this.canManage = false;
    this.canCreate = false;
    this.canCopyPermissions = false;
    this.permissionCopy = {
      source_tag_id: '',
      mode: 'replace',
      copy_restriction: true
    };
    this.permissionSourceSearch = '';
    this.permissionDestinationIds = new Set();
    this.permissionDestinationSearch = '';
    this.permissionPreview = null;
    this.permissionLoading = false;
    this.permissionMessage = '';
    this.permissionMessageType = 'success';
    this.load();
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  async load() {
    if (this.loading) return;
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/forums?_=' + Date.now())
      });
      this.items = data.items || [];
      this.permissionItems = data.permission_items || this.items;
      this.buildIndex();
      this.buildPermissionIndex();
      this.canManage = !!data.can_manage;
      this.canCreate = !!data.can_create;
      this.canCopyPermissions = !!data.can_copy_permissions;
    } catch (e) {
      this.items = [];
      this.permissionItems = [];
      this.error = 'Impossible de charger les forums.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  buildIndex() {
    this.byId = new Map();
    this.childrenMap = new Map();
    this.items.forEach(item => {
      this.byId.set(item.id, item);
      const parentId = item.parent_id ?? null;
      if (!this.childrenMap.has(parentId)) {
        this.childrenMap.set(parentId, []);
      }
      this.childrenMap.get(parentId).push(item);
    });
    this.childrenMap.forEach(children => {
      children.sort((a, b) => {
        const pa = a.position ?? 999999;
        const pb = b.position ?? 999999;
        if (pa !== pb) return pa - pb;
        return a.name.localeCompare(b.name, 'fr');
      });
    });
  }
  buildPermissionIndex() {
    this.permissionById = new Map();
    this.permissionChildrenMap = new Map();
    this.permissionItems.forEach(item => {
      this.permissionById.set(item.id, item);
    });
    this.permissionItems.forEach(item => {
      const parentId = item.parent_id !== null && this.permissionById.has(item.parent_id) ? item.parent_id : null;
      if (!this.permissionChildrenMap.has(parentId)) {
        this.permissionChildrenMap.set(parentId, []);
      }
      this.permissionChildrenMap.get(parentId).push(item);
    });
    this.permissionChildrenMap.forEach(children => {
      children.sort((a, b) => {
        const pa = a.position ?? 999999;
        const pb = b.position ?? 999999;
        if (pa !== pb) return pa - pb;
        return a.name.localeCompare(b.name, 'fr', {
          sensitivity: 'base'
        });
      });
    });
  }
  permissionChildrenOf(parentId) {
    return this.permissionChildrenMap.get(parentId ?? null) || [];
  }
  selected() {
    return this.byId.get(this.selectedId) || null;
  }
  childrenOf(parentId) {
    return this.childrenMap.get(parentId ?? null) || [];
  }
  visibleIds() {
    const q = this.filter.trim().toLocaleLowerCase('fr');
    if (!q) {
      return new Set(this.items.map(item => item.id));
    }
    const visible = new Set();
    this.items.forEach(item => {
      if (!item.name.toLocaleLowerCase('fr').includes(q)) return;
      let current = item;
      while (current && !visible.has(current.id)) {
        visible.add(current.id);
        current = current.parent_id ? this.byId.get(current.parent_id) : null;
      }
    });
    return visible;
  }
  renderBranch(item, depth, visibleIds) {
    if (depth === void 0) {
      depth = 0;
    }
    if (!visibleIds.has(item.id)) return null;
    const children = this.childrenOf(item.id).filter(child => visibleIds.has(child.id));
    return m('.ValModerationForumBranch', {
      key: item.id
    }, [m('button.ValModerationForumRow', {
      type: 'button',
      className: this.selectedId === item.id ? 'is-selected' : '',
      onclick: () => {
        this.selectedId = item.id;
        this.moveParentId = item.parent_id === null ? '' : String(item.parent_id);
        m.redraw();
      }
    }, [m('span.ValModerationForumIndent', {
      style: `width:${depth * 22}px`
    }), depth > 0 ? m('span.ValModerationForumTreeMark', '↳') : null, m('span.ValModerationForumName', item.name), m('span.ValModerationForumCount', item.discussion_count.toLocaleString('fr-FR'))]), children.length ? m('.ValModerationForumChildren', children.map(child => this.renderBranch(child, depth + 1, visibleIds))) : null]);
  }
  async runReorder(direction) {
    const selected = this.selected();
    if (!selected || this.moveLoading || !this.canManage || !selected.can_edit || !['up', 'down'].includes(direction)) {
      return;
    }
    this.moveLoading = true;
    this.error = '';
    try {
      await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/reorder'),
        body: {
          tag_id: selected.id,
          direction
        }
      });
      await this.load();
    } catch (e) {
      this.error = 'Impossible de modifier l’ordre du forum.';
    } finally {
      this.moveLoading = false;
      m.redraw();
    }
  }
  async runMove() {
    const selected = this.selected();
    if (!selected || this.moveLoading || !this.canManage || !selected.can_edit) {
      return;
    }
    const parentId = this.moveParentId === '' ? null : Number(this.moveParentId);
    const currentParentId = selected.parent_id === null ? null : Number(selected.parent_id);
    if (parentId === currentParentId) return;
    const targetName = parentId === null ? 'la racine' : `« ${this.byId.get(parentId)?.name || '#' + parentId} »`;
    if (!confirm(`Déplacer « ${selected.name} » vers ${targetName} ?`)) {
      return;
    }
    this.moveLoading = true;
    this.error = '';
    try {
      await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/move'),
        body: {
          tag_id: selected.id,
          parent_id: parentId
        }
      });
      const selectedId = selected.id;
      await this.load();
      this.selectedId = selectedId;
      const refreshed = this.selected();
      this.moveParentId = refreshed && refreshed.parent_id !== null ? String(refreshed.parent_id) : '';
    } catch (e) {
      this.error = 'Le déplacement du forum a échoué.';
    } finally {
      this.moveLoading = false;
      m.redraw();
    }
  }
  async runRename() {
    const selected = this.selected();
    if (!selected || this.moveLoading || !this.canManage || !selected.can_edit) {
      return;
    }
    const name = prompt('Nouveau nom du forum :', selected.name);
    if (name === null) {
      return;
    }
    const newName = name.trim();
    if (!newName || newName === selected.name) {
      return;
    }
    this.moveLoading = true;
    this.error = '';
    try {
      await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/rename'),
        body: {
          tag_id: selected.id,
          name: newName
        }
      });
      const selectedId = selected.id;
      await this.load();
      this.selectedId = selectedId;
    } catch (e) {
      this.error = 'Le renommage du forum a échoué.';
    } finally {
      this.moveLoading = false;
      m.redraw();
    }
  }
  async runCreate() {
    const selected = this.selected();
    if (!selected || selected.parent_id !== null || !this.canManage || !this.canCreate || this.createLoading) {
      return;
    }
    const name = this.createName.trim();
    const newSlug = this.createSlug.trim();
    if (!name || !newSlug) {
      this.error = 'Le nom et le slug sont obligatoires.';
      return;
    }
    this.createLoading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/create'),
        body: {
          name,
          slug: newSlug,
          parent_id: selected.id
        }
      });
      this.createName = '';
      this.createSlug = '';
      const createdId = data.item?.id || null;
      await this.load();
      if (createdId) {
        this.selectedId = createdId;
        const created = this.selected();
        this.moveParentId = created?.parent_id !== null ? String(created.parent_id) : '';
      }
    } catch (e) {
      this.error = 'La création du sous-forum a échoué.';
    } finally {
      this.createLoading = false;
      m.redraw();
    }
  }
  forumDepth(item) {
    let depth = 0;
    let current = item;
    while (current && current.parent_id !== null) {
      depth += 1;
      current = this.byId.get(current.parent_id) || null;
      if (depth > 20) break;
    }
    return depth;
  }
  forumOptionLabel(item) {
    const depth = this.forumDepth(item);
    const prefix = depth > 0 ? `${'\u00a0\u00a0'.repeat(depth)}↳ ` : '';
    return `${prefix}${item.name} (#${item.id})`;
  }
  permissionDepth(item) {
    let depth = 0;
    let current = item;
    while (current && current.parent_id !== null) {
      const parent = this.permissionById.get(current.parent_id) || null;
      if (!parent) break;
      depth += 1;
      current = parent;
      if (depth > 20) break;
    }
    return depth;
  }
  permissionForumOptionLabel(item) {
    const depth = this.permissionDepth(item);
    const prefix = depth > 0 ? `${'\u00a0\u00a0'.repeat(depth)}↳ ` : '';
    return `${prefix}${item.name} (#${item.id})`;
  }
  permissionOrderedItems() {
    const result = [];
    const visited = new Set();
    const append = item => {
      if (!item || visited.has(item.id)) return;
      visited.add(item.id);
      result.push(item);
      this.permissionChildrenOf(item.id).forEach(child => append(child));
    };
    this.permissionChildrenOf(null).forEach(root => append(root));
    this.permissionItems.forEach(item => append(item));
    return result;
  }
  selectedPermissionSource() {
    return this.permissionOrderedItems().find(item => String(item.id) === String(this.permissionCopy.source_tag_id)) || null;
  }
  visiblePermissionSources() {
    if (!this.normalizePermissionSearch(this.permissionSourceSearch)) {
      return [];
    }
    return this.permissionOrderedItems().filter(item => this.permissionSourceMatches(item));
  }
  selectPermissionSource(item) {
    this.permissionCopy.source_tag_id = String(item.id);
    this.permissionDestinationIds.delete(String(item.id));
    this.permissionSourceSearch = '';
    this.permissionPreview = null;
    this.permissionMessage = '';
  }
  permissionDestinationLabel(item) {
    const names = [item.name];
    let current = item;
    while (current && current.parent_id !== null) {
      current = this.permissionById.get(current.parent_id) || null;
      if (current) {
        names.unshift(current.name);
      }
      if (names.length > 20) break;
    }
    return `${names.join(' → ')} (#${item.id})`;
  }
  normalizePermissionSearch(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr').trim();
  }
  permissionSourceMatches(item) {
    const q = this.normalizePermissionSearch(this.permissionSourceSearch);
    if (!q) return true;
    return this.normalizePermissionSearch(`${this.permissionDestinationLabel(item)} ${item.slug || ''}`).includes(q);
  }
  permissionDestinationMatches(item) {
    if (String(item.id) === String(this.permissionCopy.source_tag_id)) {
      return false;
    }
    const q = this.normalizePermissionSearch(this.permissionDestinationSearch);
    if (!q) return true;
    return this.normalizePermissionSearch(`${this.permissionDestinationLabel(item)} ${item.slug || ''}`).includes(q);
  }
  togglePermissionDestination(id) {
    const key = String(id);
    if (this.permissionDestinationIds.has(key)) {
      this.permissionDestinationIds.delete(key);
    } else {
      this.permissionDestinationIds.add(key);
    }
    this.permissionPreview = null;
    this.permissionMessage = '';
  }
  clearPermissionDestinations() {
    this.permissionDestinationIds.clear();
    this.permissionPreview = null;
    this.permissionMessage = '';
  }
  async previewPermissionCopy() {
    const source = this.permissionCopy.source_tag_id;
    const destinationIds = Array.from(this.permissionDestinationIds);
    this.permissionMessage = '';
    this.permissionPreview = null;
    if (!source || !destinationIds.length) {
      this.permissionMessageType = 'error';
      this.permissionMessage = 'Choisis un forum source et au moins un forum destination.';
      return;
    }
    this.permissionLoading = true;
    const qs = new URLSearchParams({
      source_tag_id: source,
      destination_tag_ids: destinationIds.join(',')
    });
    try {
      this.permissionPreview = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/forums/permission-copy?' + qs.toString())
      });
    } catch (e) {
      this.permissionMessageType = 'error';
      this.permissionMessage = 'Erreur pendant la prévisualisation des permissions.';
    } finally {
      this.permissionLoading = false;
      m.redraw();
    }
  }
  async applyPermissionCopy() {
    if (!this.permissionPreview || this.permissionLoading) return;
    const source = this.permissionPreview.source;
    const destinations = this.permissionPreview.destinations || [];
    const modeLabel = this.permissionCopy.mode === 'replace' ? 'REMPLACER' : 'FUSIONNER avec';
    const names = destinations.map(destination => `• ${destination.name} (#${destination.id})`).join('\n');
    if (!confirm(`${modeLabel} les permissions de ${destinations.length} forum(s) par celles de « ${source.name} » ?\n\n` + `${names}\n\n` + `Copier aussi l’état « Restreindre ce tag » : ` + `${this.permissionCopy.copy_restriction ? 'oui' : 'non'}`)) {
      return;
    }
    this.permissionLoading = true;
    this.permissionMessage = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/permission-copy'),
        body: {
          source_tag_id: this.permissionCopy.source_tag_id,
          destination_tag_ids: Array.from(this.permissionDestinationIds),
          mode: this.permissionCopy.mode,
          copy_restriction: this.permissionCopy.copy_restriction
        }
      });
      const results = data.destinations || [];
      const count = results.length;
      const copiedRows = results.reduce((total, destination) => total + Number(destination.copied_rows || 0), 0);
      await this.load();
      this.permissionPreview = null;
      this.permissionMessageType = 'success';
      this.permissionMessage = `Modèle appliqué à ${count} forum${count > 1 ? 's' : ''}` + ` — ${copiedRows} ligne${copiedRows !== 1 ? 's' : ''} ajoutée${copiedRows !== 1 ? 's' : ''}.`;
    } catch (e) {
      this.permissionMessageType = 'error';
      this.permissionMessage = 'Erreur pendant la copie des permissions.';
    } finally {
      this.permissionLoading = false;
      m.redraw();
    }
  }
  permissionSummary(data) {
    const permissions = data || {};
    const names = Object.keys(permissions);
    if (!names.length) {
      return m('p.ValModerationPermissionCopy-empty', 'Aucune permission spécifique enregistrée pour ce forum.');
    }
    return m('table.ValModerationPermissionTable', [m('thead', m('tr', [m('th', 'Permission'), m('th', 'Groupes')])), m('tbody', names.map(name => m('tr', [m('td', name), m('td', permissions[name].join(', '))])))]);
  }
  permissionCopyBlock() {
    const preview = this.permissionPreview;
    const visibleDestinations = this.permissionOrderedItems().filter(item => this.permissionDestinationMatches(item));
    const selectedCount = this.permissionDestinationIds.size;
    const selectedSource = this.selectedPermissionSource();
    const visibleSources = this.visiblePermissionSources();
    const sourceSearchActive = !!this.normalizePermissionSearch(this.permissionSourceSearch);
    return m('.ValModerationPermissionCopy', [m('h3', 'Copier les permissions d’un forum'), m('p.helpText', 'Choisis un forum modèle, puis un ou plusieurs forums cibles. ' + 'La prévisualisation est obligatoire avant toute modification.'), m('.ValModerationPermissionCopy-layout', [m('.ValModerationPermissionCopy-settings', [m('.ValModerationField', [m('span', 'Forum modèle'), m('input.FormControl.ValModerationPermissionCopy-search', {
      type: 'search',
      value: this.permissionSourceSearch,
      placeholder: selectedSource ? 'Rechercher un autre forum modèle…' : 'Rechercher le forum modèle…',
      disabled: this.permissionLoading,
      oninput: e => {
        this.permissionSourceSearch = e.target.value;
        this.permissionPreview = null;
        this.permissionMessage = '';
      }
    }), selectedSource ? m('.ValModerationPermissionCopy-sourceSelected', [m('span', 'Modèle sélectionné'), m('strong', this.permissionDestinationLabel(selectedSource))]) : null, sourceSearchActive ? m('.ValModerationPermissionCopy-sourceList', visibleSources.length ? visibleSources.map(item => m('button.ValModerationPermissionCopy-source', {
      key: item.id,
      type: 'button',
      className: String(item.id) === String(this.permissionCopy.source_tag_id) ? 'is-selected' : '',
      disabled: this.permissionLoading,
      onclick: () => this.selectPermissionSource(item)
    }, this.permissionDestinationLabel(item))) : m('p.ValModerationPermissionCopy-empty', 'Aucun forum correspondant.')) : !selectedSource ? m('p.ValModerationPermissionCopy-searchHint', 'Saisis quelques lettres : les forums correspondants apparaîtront ici.') : null]), m('label.ValModerationField', [m('span', 'Mode de copie'), m('select.FormControl', {
      value: this.permissionCopy.mode,
      disabled: this.permissionLoading,
      onchange: e => {
        this.permissionCopy.mode = e.target.value;
        this.permissionPreview = null;
        this.permissionMessage = '';
      }
    }, [m('option', {
      value: 'replace'
    }, 'Remplacer les permissions des cibles'), m('option', {
      value: 'merge'
    }, 'Fusionner avec les permissions existantes')])]), m('label.ValModerationPermissionCopy-check', [m('input', {
      type: 'checkbox',
      checked: this.permissionCopy.copy_restriction,
      disabled: this.permissionLoading,
      onchange: e => {
        this.permissionCopy.copy_restriction = e.target.checked;
        this.permissionPreview = null;
        this.permissionMessage = '';
      }
    }), m('span', 'Copier aussi l’état « Restreindre ce tag »')])]), m('.ValModerationPermissionCopy-destinations', [m('.ValModerationPermissionCopy-destinationsHeader', [m('strong', `Forums cibles (${selectedCount} sélectionné${selectedCount > 1 ? 's' : ''})`), selectedCount ? m('button.Button.Button--text', {
      type: 'button',
      disabled: this.permissionLoading,
      onclick: () => this.clearPermissionDestinations()
    }, 'Tout désélectionner') : null]), m('input.FormControl.ValModerationPermissionCopy-search', {
      type: 'search',
      value: this.permissionDestinationSearch,
      placeholder: 'Rechercher un forum cible…',
      disabled: this.permissionLoading,
      oninput: e => {
        this.permissionDestinationSearch = e.target.value;
      }
    }), m('.ValModerationPermissionCopy-destinationList', visibleDestinations.length ? visibleDestinations.map(item => m('label.ValModerationPermissionCopy-destination', {
      key: item.id
    }, [m('input', {
      type: 'checkbox',
      checked: this.permissionDestinationIds.has(String(item.id)),
      disabled: this.permissionLoading,
      onchange: () => this.togglePermissionDestination(item.id)
    }), m('span', this.permissionDestinationLabel(item))])) : m('p.ValModerationPermissionCopy-empty', 'Aucun forum correspondant.'))])]), m('.ValModerationPermissionCopy-actions', [m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.permissionLoading || !this.permissionCopy.source_tag_id || !selectedCount,
      onclick: () => this.previewPermissionCopy()
    }, this.permissionLoading ? 'Traitement…' : 'Prévisualiser la copie')]), this.permissionMessage ? m(`.Alert.Alert--${this.permissionMessageType}.ValModerationPermissionCopy-message`, this.permissionMessage) : null, preview ? m('.ValModerationPermissionPreview', [m('h4', 'Forum modèle'), m('.ValModerationPermissionCard.ValModerationPermissionCard--source', [m('h4', `${preview.source.name} (#${preview.source.id})`), m('p', `${preview.source.row_count} ligne(s) de permissions — ` + `forum ${preview.source.is_restricted ? 'restreint' : 'non restreint'}`), this.permissionSummary(preview.source.permissions)]), m('h4.ValModerationPermissionPreview-destinationsTitle', `Forums cibles (${preview.destinations.length})`), m('.ValModerationPermissionCards', preview.destinations.map(destination => m('.ValModerationPermissionCard', {
      key: destination.id
    }, [m('h4', `${destination.name} (#${destination.id})`), m('p', `${destination.row_count} ligne(s) actuellement — ` + `forum ${destination.is_restricted ? 'restreint' : 'non restreint'}`), this.permissionSummary(destination.permissions)]))), m('.ValModerationPermissionCopy-actions', [m('button.Button.Button--danger', {
      type: 'button',
      disabled: this.permissionLoading,
      onclick: () => this.applyPermissionCopy()
    }, this.permissionLoading ? 'Application…' : this.permissionCopy.mode === 'replace' ? 'Appliquer le modèle aux forums sélectionnés' : 'Fusionner le modèle avec les forums sélectionnés')])]) : null]);
  }
  updateForumTreeFade(tree) {
    if (!tree) return;
    const moreBelow = tree.scrollHeight - tree.scrollTop - tree.clientHeight > 3;
    tree.classList.toggle('val-has-more-below', moreBelow);
  }
  syncForumTreeHeight(tree) {
    if (!tree) return;
    requestAnimationFrame(() => {
      const layout = tree.closest('.ValModerationForums-layout');
      const details = layout?.querySelector('.ValModerationForums-details');
      const populated = details && !details.querySelector('.ValModerationForums-placeholder');
      if (window.innerWidth <= 800 || !populated) {
        tree.style.maxHeight = '';
      } else {
        const rightHeight = details.getBoundingClientRect().height;
        const viewportLimit = window.innerHeight * 0.50;
        tree.style.maxHeight = `${Math.min(rightHeight, viewportLimit)}px`;
      }
      this.updateForumTreeFade(tree);
    });
  }
  setupForumTree(vnode) {
    const tree = vnode.dom;
    if (tree.dataset.valForumTreeReady !== '1') {
      tree.dataset.valForumTreeReady = '1';
      tree.addEventListener('scroll', () => this.updateForumTreeFade(tree), {
        passive: true
      });
      window.addEventListener('resize', () => this.syncForumTreeHeight(tree), {
        passive: true
      });
      const layout = tree.closest('.ValModerationForums-layout');
      const details = layout?.querySelector('.ValModerationForums-details');
      if (details && window.ResizeObserver) {
        this.forumTreeResizeObserver?.disconnect();
        this.forumTreeResizeObserver = new ResizeObserver(() => this.syncForumTreeHeight(tree));
        this.forumTreeResizeObserver.observe(details);
      }
    }
    this.syncForumTreeHeight(tree);
  }
  view() {
    const selected = this.selected();
    const roots = this.childrenOf(null);
    const visibleIds = this.visibleIds();
    return m('.ValModerationForums', [m('.ValModerationForums-toolbar', [m('input.FormControl', {
      type: 'search',
      placeholder: 'Rechercher un forum…',
      value: this.filter,
      oninput: e => {
        this.filter = e.target.value;
        m.redraw();
      }
    })]), this.error ? m('.Alert.Alert--error', this.error) : null, this.loading ? m('.ValModerationForums-loading', 'Chargement…') : m('.ValModerationForums-layout', [m('.ValModerationForums-tree', {
      oncreate: vnode => this.setupForumTree(vnode),
      onupdate: vnode => this.syncForumTreeHeight(vnode.dom)
    }, roots.length ? roots.filter(item => visibleIds.has(item.id)).map(item => this.renderBranch(item, 0, visibleIds)) : m('.ValModerationForums-empty', 'Aucun forum trouvé.')), m('.ValModerationForums-details', selected ? [m('h3', selected.name), m('dl.ValModerationForumDetails', [m('dt', 'ID'), m('dd', selected.id), m('dt', 'Slug'), m('dd', selected.slug), m('dt', 'Discussions'), m('dd', selected.discussion_count.toLocaleString('fr-FR')), m('dt', 'Parent'), m('dd', selected.parent_id ? this.byId.get(selected.parent_id)?.name || `#${selected.parent_id}` : 'Racine'), m('dt', 'Position'), m('dd', selected.position ?? '—'), m('dt', 'Restreint'), m('dd', selected.is_restricted ? 'Oui' : 'Non'), m('dt', 'Masqué'), m('dd', selected.is_hidden ? 'Oui' : 'Non')]), this.canManage && selected.can_edit ? m('button.Button', {
      type: 'button',
      onclick: () => this.runRename()
    }, 'Renommer') : null, this.canManage && selected.can_edit ? m('.ValModerationForumReorder', [m('h4', 'Ordre du forum'), m('button.Button', {
      type: 'button',
      disabled: this.moveLoading,
      onclick: () => this.runReorder('up')
    }, '↑ Monter'), m('button.Button', {
      type: 'button',
      disabled: this.moveLoading,
      onclick: () => this.runReorder('down')
    }, '↓ Descendre')]) : null, m('.ValModerationForumMove', [m('h4', 'Déplacer le forum'), m('label.ValModerationField', [m('span', 'Déplacer sous'), m('select.FormControl', {
      value: this.moveParentId,
      disabled: this.moveLoading || !this.canManage || !selected.can_edit,
      onchange: e => {
        this.moveParentId = e.target.value;
      }
    }, [m('option', {
      value: ''
    }, 'Racine'), ...this.childrenOf(null).filter(item => item.id !== selected.id).map(item => m('option', {
      value: String(item.id)
    }, item.name))])]), this.childrenOf(selected.id).length ? m('.helpText', 'Ce forum possède des sous-forums : il ne peut pas devenir un sous-forum.') : null, m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.moveLoading || !this.canManage || !selected.can_edit || (this.moveParentId === '' ? null : Number(this.moveParentId)) === (selected.parent_id === null ? null : Number(selected.parent_id)) || this.moveParentId !== '' && this.childrenOf(selected.id).length > 0,
      onclick: () => this.runMove()
    }, this.moveLoading ? 'Déplacement…' : 'Déplacer')]), selected.parent_id === null ? m('form.ValModerationForumCreate', {
      onsubmit: e => {
        e.preventDefault();
        this.runCreate();
      }
    }, [m('h4', 'Créer un sous-forum'), m('label.ValModerationField', [m('span', 'Nom'), m('input.FormControl', {
      type: 'text',
      value: this.createName,
      disabled: this.createLoading,
      oninput: e => {
        this.createName = e.target.value;
        this.createSlug = slug(e.target.value);
        m.redraw();
      }
    })]), m('label.ValModerationField', [m('span', 'Slug'), m('input.FormControl', {
      type: 'text',
      value: this.createSlug,
      disabled: this.createLoading,
      oninput: e => {
        this.createSlug = e.target.value;
      }
    })]), m('button.Button.Button--primary', {
      type: 'submit',
      disabled: this.createLoading || !this.canManage || !this.canCreate || !this.createName.trim() || !this.createSlug.trim()
    }, this.createLoading ? 'Création…' : 'Créer le sous-forum')]) : m('.helpText', 'La création est disponible depuis un forum racine.')] : m('.ValModerationForums-placeholder', 'Sélectionne un forum dans l’arborescence.'))]), m(ForumTrashPanel, {
      onChanged: () => this.load()
    }), this.canCopyPermissions ? this.permissionCopyBlock() : null]);
  }
}